import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { httpVersion, superAdminRoutes } from 'src/consts/http-routes';
import { ModelHeaderComponent } from 'src/app/common-components/model-header/model-header.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-manage-subscription-pop-up',
  templateUrl: './manage-subscription-pop-up.component.html',
  styleUrls: ['./manage-subscription-pop-up.component.scss'],
  imports: [ModelHeaderComponent, CommonModule, TranslateModule]
})
export class ManageSubscriptionPopUpComponent implements OnInit {
  title = this.translate.instant('Manage Subscription');
  planDatas: any[] = []; // Updated to match the new response structure
  selectedPlan: any = null;

  constructor(
    public dialogRef: MatDialogRef<ManageSubscriptionPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    public uiSpinner: UiSpinnerService,
    public translate: TranslateService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.getPlanDetails();
  }

  async getPlanDetails() {
    this.uiSpinner.spin$.next(true);
    const response = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.gat_all_priceplan);
    this.uiSpinner.spin$.next(false);
    if (response.status) {
      this.planDatas = response.data;
    }
  }

  selectPlan(plan: any): void {
    this.selectedPlan = plan;
  }

  saveData(): void {
    if (this.selectedPlan) {
      this.dialogRef.close(this.selectedPlan);
    } else {
      alert('Please select a plan before proceeding!');
    }
  }
}
